<template>

    <!-- container -->
    <div id="release_page" class="container mb-5">

      <h4 class="mt-0" v-show="loading">{{ $t("message_loading") }}</h4>
      <error v-if="errored" :code=errorCode :message=errorMessage></error>

      <!-- section -->
      <section v-else>

        <!--release -->
        <div v-if="release && release.id">

          <!--release-id -->
          <div :release_id=release.id>
            <div class="row release_print_row">
              <div class="col-lg-8 ">
                <div id="release_intro">
                  <div class="intro pr-2">
                    <p class="heading_grey h3 mt-0 text-uppercase">{{ release.release_type_name }}</p>
                    <!-- Archive or Preview Status -->
                    <div class="p-3 mb-3" id="archived" v-if="release.previous_administration_flag">
                        <p><strong>{{ $t("release_archive") }}</strong></p>
                        <p class="mb-0"><strong>{{ $t("message_archive") }}</strong></p>
                    </div>
                    <!-- Preview Status -->
                    <div class="p-3 mb-3" id="preview" v-if="releaseVueType == 'Preview'">
                        <p><strong>{{ releaseVueType }}</strong></p>
                        <p><strong>{{ $t("message_preview") }} {{ release.preview_expires }}</strong></p>
                    </div>
                    <h1 class="release_title_mobile" v-html="release.content_title"></h1>
                    <p class="ontario-lead-statement">{{ release.content_subtitle }}</p>
                  </div><!-- intro -->
                  <p class="mb-0"><strong>{{ release.release_date_time_formatted }}</strong></p>
                  <!-- Lead Ministry -->
                  <p class="mb-0">
                    <router-link :to="{ name: 'ministry', params: { acronym: release.ministry_acronym.toLowerCase() } }">
                      {{ release.ministry_abbreviated }}
                    </router-link>
                  </p>
                  <!-- Partner Ministries -->
                  <p class="mb-0" v-for="ministry in release.partner_ministries">
                    <router-link :to="{ name: 'ministry',
                                        params: { acronym: release.language == 'fr'
                                                            ? ministry.acronym_fr.toLowerCase()
                                                            : ministry.acronym.toLowerCase()
                                                }
                                      }"
                    >
                      {{ release.language == 'fr'
                          ? ministry.name_fr_abbreviated
                          : ministry.name_abbreviated
                      }}
                    </router-link>
                  </p>
                </div><!-- release_intro -->
              </div> <!-- col-lg-8 -->
              <hr class="bold_hr_super ml-3 mr-3">
            </div> <!--row -->
          </div>
          <!--release-id -->

          <div class="row release_print_row">

            <div class="col-lg-8">

              <!-- Mobile share -->
              <span id="share_mob">
                <a id="share_mob_list" name="share" />
                <h3 class="tocSmall release_title_mobile">{{ $t("release_share") }}</h3>
                <a target="_blank" :href="'http://twitter.com/intent/tweet?url=' + this.shareLink + '&text=' + release.clean_title"><img class="mr-3" :src="$vueAssets + 'twitter.png'" :alt="$t('release_twitter_accessibility')"></a>
                <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + this.shareLink + '&title=' + release.clean_title"><img class="mr-3" :src="$vueAssets + 'facebook.png'" :alt="$t('release_facebook_accessibility')"></a>
                <a :href="'mailto:?subject=' + release.clean_title + '&body=' + this.shareLink"><img class="mr-3" :src="$vueAssets + 'email.png'" :alt="$t('release_email_accessibility')"></a>
                <a href="#" @click="printWindow()"><img class="mr-3" :src="$vueAssets + 'print.png'" :alt="$t('release_print_accessibility')"></a>
                <hr class="bold_hr">
              </span>
              <!-- Mobile share -->

              <!-- Table of Contents -->
              <div id="toc">
                <h3 class="release_title_mobile">{{ $t("release_table") }}</h3>
                <ol id="table_cols" class="pl_13 mb-0 ml-2">
                  <li><a href="#content">{{ $t("release_content") }}</a></li>
                  <li v-if="release.quickfacts && release.quickfacts.length"><a href="#quickfacts">{{ $t("release_quickfacts") }}</a></li>
                  <li v-if="release.quotes && release.quotes.length"><a href="#quotes">{{ $t("release_quotes") }}</a></li>
                  <li v-if="release.release_crossreferences_resources && release.release_crossreferences_resources.length"><a href="#resources">{{ $t("release_resources") }}</a></li>
                  <li v-if="release.assets && release.assets.length"><a href="#assets">{{ $t("release_assets") }}</a></li>
                  <li v-if="release.topics && release.topics.length"><a href="#topics">{{ $t("release_topics") }}</a></li>
                  <li v-if="(release.streams && release.streams.length) && windowWidth <= 992"><a href="#timeline">{{ $t("release_timeline") }}</a></li>
                  <li v-if="release.contacts && release.contacts.length && windowWidth <= 992"><a href="#contacts">{{ $t("release_contacts") }}</a></li>
                </ol>
                <hr class="bold_hr">
              </div>
              <!-- Table of Contents -->

              <!-- General -->
              <a id="content" name="content" />
              <h3 class="d-none tocLarge tocSmall release_title_mobile">{{ $t("release_content") }}</h3>
              <div v-if="release.content_lead" v-html="release.content_lead"></div>
              <div v-if="release.content_body" v-html="release.content_body"></div>
              <!-- Media Advisory -->
              <div v-if="release.release_type_id == 2002">
                <dl>
                  <!-- <dt> should render as html due to non-breaking spaces needed for french -->
                  <div class="row" v-if="release.additional.content_date">
                    <dt class="col-2" v-html="$t('media_advisory_date')"></dt>
                    <dd class="col-10"><span v-html="release.additional.content_date"></span></dd>
                  </div>
                  <div class="row" v-if="release.additional.content_time">
                    <dt class="col-2" v-html="$t('media_advisory_time')"></dt>
                    <dd class="col-10"><span v-html="release.additional.content_time"></span></dd>
                  </div>
                  <div class="row" v-if="release.additional.content_location">
                    <dt class="col-2" v-html="$t('media_advisory_location')"></dt>
                    <dd class="col-10"><span v-html="release.additional.content_location"></span></dd>
                  </div>
                  <div class="row" v-if="release.additional.content_livestream_url">
                    <dt class="col-2" v-html="$t('media_advisory_livestream')"></dt>
                    <dd class="col-10"><span v-html="release.additional.content_livestream_url"></span></dd>
                  </div>
                  <div class="row" v-if="release.additional.content_notes">
                    <dt class="col-2" v-html="$t('media_advisory_notes')"></dt>
                    <dd class="col-10"><span v-html="release.additional.content_notes"></span></dd>
                  </div>
                </dl>
              </div>
               <!-- EPK -->
              <div v-if="release.release_type_id == 2003">
                <!-- TODO - need to determine translation keys for these -->
                <p v-if="release.additional.content_epk_url">
                  <a :href="release.additional.content_epk_url">{{ $t('epk_download') }} {{epkAssets}}</a>
                </p>
                <p v-if="release.additional.content_nr_url">
                  <a :href="release.additional.content_nr_url">{{ $t('epk_read_release') }}</a>
                </p>
              </div>
              <hr class="bold_hr">
              <!-- General -->

              <!-- Quickfacts -->
              <div v-if="release.quickfacts && release.quickfacts.length">
                <a id="quickfacts" name="quickfacts" />
                <h3 class="tocLarge release_title_mobile">{{ $t("release_quickfacts") }}</h3>
                <div v-html="release.quickfacts"></div>
                <hr class="bold_hr">
              </div>
              <!-- Quickfacts -->

              <!-- Quotes -->
              <div v-if="release.quotes && release.quotes.length">
                <a id="quotes" name="quotes" />
                <h3 class="tocLarge release_title_mobile">{{ $t("release_quotes") }}</h3>
                <blockquote class="quote_sidebar" v-for="quote in release.quotes" v-bind:key="quote.id">
                  <p v-if="release.language == 'fr'">«&nbsp;<span v-html="quote.content"></span>&nbsp;»</p>
                  <p v-else>"<span v-html="quote.content"></span>"</p>
                  <p class="text-right pr-3"><strong>- {{ quote.author_name }} <br />{{ quote.title }}</strong></p>
                </blockquote>
                <hr class="bold_hr quote_hr_additional">
              </div>
              <!-- Quotes -->

              <!-- Resources -->
              <div v-if="release.release_crossreferences_resources && release.release_crossreferences_resources.length">
                <a id="resources" name="resources" />
                <h3 class="tocLarge tocSmall release_title_mobile">{{ $t("release_resources") }}</h3>
                <div v-html="release.release_crossreferences_resources"></div>
                <hr class="bold_hr">
              </div>
              <!-- Resources -->

              <!-- Assets -->
              <div v-if="release.media_assets">
                <a id="assets" name="assets" />
                <h3 class="tocLarge release_title_mobile">{{ $t("release_assets") }}</h3>
                <div v-html="release.media_assets"></div>
                <!-- TODO The below <assets></assets> tag is no longer relevant -->
                <!-- However keeping it around as an example of how to format assets may be handy -->
                <!-- <assets :assets="release.assets"></assets> -->
                <hr class="bold_hr">
              </div>
              <!-- Assets -->

              <!-- Topics -->
              <div v-if="release.topics && release.topics.length">
                <a id="topics" name="topics" />
                <h3 class="release_title_mobile">{{ $t("release_topics") }}</h3>
                <div class="mb-4" v-for="topics in release.topics" v-bind:key="topics.id">
                  <p class="h5 mb-0">{{ topics.label }}</p>
                  <p>{{ topics.description }} <a :href="topics.link">{{ $t("release_topics_learn") }}</a></p>
                </div>
                <hr class="bold_hr">
              </div>
              <!-- Topics -->

            </div>
            <!-- col-lg-8 -->
            <!-- col-lg-4 -->
            <div class="col-lg-4 pl-4">

              <!-- Share -->
              <span id="share_desk">
                <a id="share" name="share" />
                <h3 class="tocSmall release_title_mobile">{{ $t("release_share") }}</h3>
                <a target="_blank" :href="'http://twitter.com/intent/tweet?url=' + this.shareLink + '&text=' + release.clean_title"><img class="mr-3" :src="$vueAssets + 'twitter.png'" :alt="$t('release_twitter_accessibility')"></a>
                <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + this.shareLink + '&title=' + release.clean_title"><img class="mr-3" :src="$vueAssets + 'facebook.png'" :alt="$t('release_facebook_accessibility')"></a>
                <a :href="'mailto:?subject=' + release.clean_title + '&body=' + this.shareLink"><img class="mr-3" :src="$vueAssets + 'email.png'" :alt="$t('release_email_accessibility')"></a>
                <a href="#" @click="printWindow()"><img class="mr-3" :src="$vueAssets + 'print.png'" :alt="$t('release_print_accessibility')"></a>
                <hr class="bold_hr">
              </span>
              <!-- Share -->

              <!-- Related (Streams) -->
              <!-- A release could belong to multiple streams, for each stream, display the streams component and pass in the stream_id -->
              <!-- <div id="timeline" v-if="release.streams && release.streams.length">
                  <streams v-for="(stream, index) in release.streams" v-bind:key="index" :stream_id_prop="stream"></streams>
                  <hr class="bold_hr timeline_release_hr">
              </div> -->
              <!-- Related (Streams) -->

              <!-- Contacts -->
              <div v-if="(release.contacts && release.contacts.length)">
                <a id="contacts" name="contacts" />
                <h3 class="release_title_mobile">{{ $t("release_contacts") }}</h3>
                <div v-html="release.contacts"></div>
                <hr class="bold_hr">
              </div>
              <!-- Contacts -->

            </div>
            <!-- col-lg-4 -->

          </div>
          <!-- row-->

        </div>
        <!-- release -->

      </section>
      <!-- section -->

    </div> 
    <!-- container -->

</template>

<script>

import Assets from '../components/Assets.vue'
import Error from '../components/Error.vue'
import Streams from '../components/Streams.vue'

export default {
  components: {
    Assets,
    Error,
    Streams
  },
  data () {
    return {
      release: {},
      releaseVueType: null,
      releaseUrl: null,
      releaseContribution: null,
      utmParams: null,
      loading: true,
      errored: false,
      errorCode: null,
      errorMessage: null,
      shareLink: window.location.href,
      windowWidth: window.innerWidth,
      meta: {
        title: '',
        lead: '',
        image: '',
        twitter_handle: '',
        url: ''
      }
    }
  },
  watch: {
    // Watch the release object, and populate necessary metadata
    release: function (val) {
      this.setMetaData()
    }
  },
  // This is a function used by the vue-meta plugin
  metaInfo () {
    return {
      meta: [
        // General SEO
        { vmid: 'keywords', name: 'keywords', content: this.meta.title },
        { vmid: 'description', name: 'description', content: this.meta.lead },
        // Twitter
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:site', content: this.meta.twitter_handle },
        { name: 'twitter:title', content: this.meta.title },
        { name: 'twitter:domain', content: 'news.ontario.ca' },
        { name: 'twitter:description', content: this.meta.lead },
        { name: 'twitter:image', content: this.meta.image },
        // Facebook
        { property: 'og:title', content: this.meta.title },
        { property: 'og:type', content: 'article' },
        { property: 'og:site_name', content: 'news.ontario.ca' },
        { property: 'og:image', content: this.meta.image },
        { property: 'og:image:width', content: '600' },
        { property: 'og:image:height', content: '400' },
        { property: 'og:description', content: this.meta.lead },
        { property: 'og:url', content: this.meta.url }
      ]
    }
  },
  computed: {
    epkAssets() {
      let assets = JSON.parse(this.release.additional.content_assets)
      let string = ''
      if (assets && assets.length) {
        for (let i=0; i<assets.length; i++) {
            let translation_key = `epk_${assets[i].label.toLowerCase()}`
            if (i != assets.length - 1) {
              string += `${this.$t(translation_key)}, `
          } else {
              string += `${this.$t('epk_and')} ${this.$t(translation_key)}${this.$t('epk_files')}.`
          }
        }
      }
      return string
    },
  },
  methods: {
    determineApiCall () {
      if (this.$route.name === 'previewRelease') {
        this.fetchPreviewData()
      } else {
        this.fetchData()
      }
    },
    fetchData () {
      this.loading = true
      // #####################################################################################
      // NOTE: Determine which API call to execute (VUEMASTER 2.0)
      // #####################################################################################
      if(this.$route.params.lang === 'en') {
        this.releaseContribution = process.env.VUE_APP_ROOT_API + 'releases/' + this.$route.params.release_id + '?language=en'
      } else {
        this.releaseContribution = process.env.VUE_APP_ROOT_API + 'releases/' + this.$route.params.release_id + '?language=fr'
      }
      // Axios function
      this.$axios
        .get(this.releaseContribution)
        .then(response => {
          this.release = response.data.data
          // Set bilingual flag for APP.VUE 
          // NOTE: VUEMASTER 2.0 might have to change this code as EN and FR are shared by ID
          if (this.release.release_id_translated == null) {
            this.$root.$emit('setBilingualData', this.release.release_type_label, this.release.id, this.release.slug)
          } else {
            this.$root.$emit('setBilingualData', this.release.release_type_label, this.release.release_id_translated, this.release.slug_translated)
          }
          // Set i18n locale language for APP.VUE
          this.$root.$emit('seti18nLanguage', this.release.language)

          // Hide the language toggle if published english only or published french only
          if ([3003, 3004].includes(this.release.status_type_id)) {
            this.$root.$emit('hideLanguageToggle', true)
          }
          // Update the url (note that timing is important here, this function wont work in finally() as values update in an unexpected order)
          if (this.release.id && this.release.language) {
            this.updateUrl(this.release.language, this.release.release_type_label, this.release.id, this.release.slug)
          }
          // Update the site title
          if (this.release.clean_title) {
            this.updateSiteTitle(this.release.clean_title)
            this.fireGAEvent()
          }
        })
        .catch(error => {
          this.setErrorVariables(error.response.status, error.response.data.message)
        })
        .finally(() => (this.loading = false))
    },
    fetchPreviewData () {
      let str = this.$route.params.key
      let key = str.split('.')
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'preview', {
          params: {
            language: this.$root.$i18n.locale,
            release_id: this.$route.params.id,
            preview_key: key[0]
          }
        })
        .then(response => {
          this.release = response.data.data
          // set releaseVueType to 'Preview'
          this.releaseVueType = 'Preview'
          // Pass 'Preview' as the site title for release previews
          let releaseTitle = (this.$root.$i18n.locale == 'en') ? 'Preview' : 'French Preview'
          this.updateSiteTitle(releaseTitle)
        })
        .catch(error => {
          this.setErrorVariables(error.response.status, error.response.data.message)
        })
        .finally(() => (this.loading = false))
    },
    updateUrl (releaseLang, releaseTypeLabel, releaseId, releaseSlug) {
      if(location.search.indexOf('utm_') != -1) {
        this.utmParams = '?' + window.location.search.substring(1)
      } else {
        this.utmParams = '';
      }
      history.replaceState(
        {},
        null,
        '/' + releaseLang + '/' + releaseTypeLabel + '/' + releaseId + '/' + releaseSlug + this.utmParams
      )
      this.releaseUrl = '/' + releaseLang + '/' + releaseTypeLabel + '/' + releaseId + '/' + releaseSlug
      this.shareLink = window.location.href
      this.meta.url = window.location.href
    },
    // Update the site title to include the release title
    updateSiteTitle (releaseTitle) {
      let siteTitle = (this.$root.$i18n.locale == 'en') ? 'Ontario Newsroom' : 'Salle de presse de l’Ontario'
      document.title = releaseTitle + ' | ' + siteTitle
    },
    setMetaData () {
      // Set meta.title
      this.meta.title = this.release.clean_title
      // Strip tags and truncate lead
      let lead = this.release.content_lead ? this.release.content_lead.replace(/(<([^>]+)>)/ig, '') : ''
      lead = lead.substring(0, 200)
      this.meta.lead = lead
      // Set twitter handle based on global site language
      if (this.$root.$i18n.locale == 'en') {
        this.meta.twitter_handle = '@ongov'
      } else {
        this.meta.twitter_handle = '@ongouv'
      }
      // Set social media image
      // If there is a main photo, use it, else use default image
      if (this.release.assets && this.release.assets.length) {
        for (let i = 0; i < this.release.assets.length; i++) {
          if (this.release.assets[i].asset_type_name == "youtube") {
            this.meta.image = this.release.assets[i].cover_image_url_large
          } else if (this.release.assets[i].cover_main_image_flag == 1) {
            this.meta.image = this.release.assets[i].cover_image_url_large
            break
          } else {
            this.meta.image = process.env.VUE_APP_SOCIAL_MEDIA_DEFAULT_IMAGE
          }
        }
      } else {
        this.meta.image = process.env.VUE_APP_SOCIAL_MEDIA_DEFAULT_IMAGE
      }
    },
    fireGAEvent () {
      //window.location.href + this.utmParams
      window.dataLayer.push({
        'event': 'Pageview',
        'pagePath': window.location.href,
        'pageTitle': document.title,
        'ministryOwner': this.release.ministry_name
      })
    },
    printWindow () {
      window.print()
    },
    setErrorVariables (code, message) {
      this.errored = true
      this.errorCode = code
      this.errorMessage = message
    },
    setEventListeners () {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    }
  },
  mounted () {
    this.determineApiCall()
    this.setEventListeners()
  }
}
</script>
